module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ;  var self = this 
    ; __append("\n\n<select ")
    ; __append(escapeFn( Html.attributes(this.attributes) ))
    ; __append(" >\n    ")
    ;  if (this.showEmpty) { 
    ; __append("\n    <option value=\"\"></option>\n    ")
    ;  } 
    ; __append("\n\n    ")
    ;  if (this.prepend) { 
    ; __append("\n    ")
    ;  Util.each(this.prepend, function (item) { 
    ; __append("\n    <option\n            value=\"")
    ; __append(escapeFn( item.value ))
    ; __append("\"\n            ")
    ; __append(escapeFn( Html.selected(self.selected === item.value) ))
    ; __append("\n    >\n        ")
    ; __append(escapeFn( Html.encode(item.title) ))
    ; __append("\n    </option>\n    ")
    ;  }) 
    ; __append("\n    ")
    ;  } 
    ; __append("\n\n    ")
    ;  if (this.array.length > 0) { 
    ; __append("\n    ")
    ;  if (typeof(this.array[0]) == "object") { 
    ; __append("\n    ")
    ;  Util.each(this.array, function (item) { 
    ; __append("\n    ")
    ; 
        var value = item[self.key];
        var title = item[self.field];
    
    ; __append("\n    <option\n            value=\"")
    ; __append(escapeFn( value ))
    ; __append("\"\n            ")
    ; __append(escapeFn( Html.selected(self.selected === value) ))
    ; __append("\n    >\n        ")
    ; __append(escapeFn( title ))
    ; __append("\n    </option>\n    ")
    ;  }) 
    ; __append("\n    ")
    ;  } else { 
    ; __append("\n    ")
    ;  Util.each(this.array, function (title, value) { 
    ; __append("\n    <option\n            value=\"")
    ; __append(escapeFn( value ))
    ; __append("\"\n            ")
    ; __append(escapeFn( Html.selected(self.selected === value) ))
    ; __append("\n    >\n        ")
    ; __append(escapeFn( title ))
    ; __append("\n    </option>\n    ")
    ;  }) 
    ; __append("\n    ")
    ;  } 
    ; __append("\n    ")
    ;  } 
    ; __append("\n</select>\n")
  }
  return __output.join("");

}